// extracted by mini-css-extract-plugin
module.exports = {"section":"_3oAYs0","opened":"h6CVD-","arrow":"_2RdHiN","title":"_2egySM","nav":"_1PmuEZ","navItem":"_2oQ6XR"};